/**
 * Host classification shared by RouteSeo and tests.
 * Mirrors isTenantSubdomain() in Routes/routes.jsx: anything that is not the
 * apex, www, localhost or a loopback address is a tenant portal.
 */
import { APEX_HOST, SITE_HOST } from './siteConfig';

const BASE_DOMAIN = (typeof process !== 'undefined' && process.env && process.env.REACT_APP_BASE_DOMAIN) || APEX_HOST;

export function isMainDomainHost(hostname) {
  const h = String(hostname || '').toLowerCase();
  if (!h) return true; // jsdom / prerender without a host → treat as main
  if (h === 'localhost' || h.startsWith('127.') || h === '[::1]' || h === '0.0.0.0') return true;
  if (h === BASE_DOMAIN || h === `www.${BASE_DOMAIN}`) return true;
  if (h === APEX_HOST || h === SITE_HOST) return true;
  // Any other *.theskillgenie.com host is a tenant portal.
  return !h.endsWith(`.${BASE_DOMAIN}`);
}
